import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useDispatch } from "react-redux";
import { processShareToken, validateShareToken } from "../../store/usersSlice";
import "./ShareAccessPage.css";
import { OrbitProgress } from "react-loading-indicators";
import { setRedirectingFromSharing } from "../../store/appSlice";

function getQueryParam(search, param) {
  const params = new URLSearchParams(search);
  return params.get(param);
}

const ShareAccessPage = () => {
  const navigate = useNavigate();
  const { loginFromShared, setSharedToken } = useAuth();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    sharingProcess();
  }, []);

  const sharingProcess = async () => {
    const token = getQueryParam(location.search, "token");
    const userToken = localStorage.getItem("access_token");

    dispatch(validateShareToken(token)).then((res) => {
      if (!res.error) {
        dispatch(processShareToken(token)).then(async (res2) => {
          if (!res2.error) {
            let success;
            if (userToken) {
              success = await loginFromShared(
                userToken,
                res.payload.resourceType,
                res.payload.resourceId
              );
            } else {
              success = false;
            }
            dispatch(setRedirectingFromSharing(true));
            if (!success) {
              setSharedToken(token);
              const navPath =
                res.payload.role !== "VIEWER"
                  ? "?shared=1"
                  : "?shared=1&role=viewer";
              navigate(res.payload.redirectPath + navPath);
            } else {
              navigate(res.payload.redirectPath);
            }
          }
        });
      }
    });
  };

  return (
    <div className="App">
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <OrbitProgress color="#C1C7D4" />
      </div>
    </div>
  );
};

export default ShareAccessPage;
